import { OverlayLoader } from 'components/Loaders'
import Text from 'components/Text'
import productName from 'constants/productName'
import { QRCodeCanvas } from 'qrcode.react'
import React from 'react'
import styled from 'styled-components'

import { PropsType } from './index'

const Wrapper = styled.div`
  position: relative;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 256px;
  height: 256px;
  margin-top: 2rem;
`

const Seed = styled(Text)`
  margin: 1rem;
`

const QrCode = ({ email, tOtpConfig }: PropsType) => {
  const isLoading = tOtpConfig.seed === ''
  const description = typeof email === 'string' ? `${productName} (${email})` : productName

  return (
    <>
      <Wrapper>
        {!isLoading && (
          <QRCodeCanvas
            level='M'
            size={256}
            value={`otpauth://totp/${encodeURIComponent(description)}?secret=${tOtpConfig.seed}`}
          />
        )}
        {isLoading && <OverlayLoader />}
        <Seed color='black' e2e='2faSeedSecret' weight={400}>
          {tOtpConfig.seed}
        </Seed>
      </Wrapper>
    </>
  )
}

export default QrCode
